import { ReactComponent as CheckIcon } from '../../../../assets/icons/checkbox-circle-fill.svg';
import { ReactComponent as CopyIcon } from '../../../../assets/icons/copy2.svg';
import classes from './CashDepositExternalDetailsRow.module.scss';

type CashDepositExternalDetailsRowProps = {
  label: string;
  value: string;
  copiedKey: string | null;
  handleCopy: (label: string, value: string) => void;
};

export const CashDepositExternalDetailsRow = ({
  label,
  value,
  copiedKey,
  handleCopy,
}: CashDepositExternalDetailsRowProps) => {
  return (
    <div className={classes.row}>
      <span className={classes.rowLabel}>{label}</span>
      <button
        type="button"
        className={classes.rowValue}
        onClick={() => handleCopy(label, value)}
      >
        {value}
        {copiedKey === label ? <CheckIcon className={classes.copiedIcon} /> : <CopyIcon />}
      </button>
    </div>
  );
};
